import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { PenTool, ArrowLeft, Edit3 } from 'lucide-react';
import LoginForm from './LoginForm';
import BlogEditorForm from './BlogEditorForm';
import { useAdminAuth, useBlogEditor } from '../lib/hooks';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  
  const { 
    isLoggedIn, 
    password, 
    setPassword, 
    handleLogin, 
    authLoading, 
    handleLogout 
  } = useAdminAuth();

  const { 
    formData, 
    loading, 
    handleChange, 
    handleSubmit 
  } = useBlogEditor(isLoggedIn ? slug : null, navigate, handleLogout);

  if (!isLoggedIn) {
    return (
      <LoginForm 
        password={password} 
        setPassword={setPassword} 
        handleLogin={handleLogin} 
        loading={authLoading} 
      />
    );
  }

  return (
    <div className="w-full max-w-4xl mx-auto px-6 py-12 md:py-20 animate-in fade-in duration-500">
      <div className="mb-8 flex items-center justify-between">
        <div>
          <Link to="/blog" className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground mb-4 transition-colors">
            <ArrowLeft size={16} className="mr-2" /> Back to Blog
          </Link>
          <h1 className="text-3xl md:text-4xl font-heading font-bold flex items-center gap-3">
            {slug ? <Edit3 className="text-accent" /> : <PenTool className="text-accent" />}
            {slug ? 'Edit Post' : 'Write New Post'}
          </h1>
        </div>
      </div>

      <BlogEditorForm 
        formData={formData} 
        handleChange={handleChange} 
        handleSubmit={handleSubmit} 
        loading={loading} 
        isEditing={!!slug} 
      />
    </div>
  );
};

export default AdminDashboard;
